import { render, staticRenderFns } from "./GraphFungicide.vue?vue&type=template&id=47dbff67&"
import script from "./GraphFungicide.vue?vue&type=script&lang=js&"
export * from "./GraphFungicide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports